export default __webpack_public_path__ + "static/media/fb.3f7115f9.svg";